import { Injectable, Injector } from "@angular/core";
import { BaseResourceService, RequisicaoSubelemento } from "eddydata-lib";

@Injectable({
    providedIn: 'root'
})
export class RequisicaoSubelementoService extends BaseResourceService<RequisicaoSubelemento>{

    constructor(
        protected injector: Injector
    ) {
        super('requisicao-subelementos', injector)
    }
}